import { useEffect } from 'react';
import '../styles/AboutUs.css';

const AboutUs = () => {
  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="about-hero">
        <div className="hero-bg">
          <div className="bg-card">
            <img src="/assets/image 5.jpg" alt="Oliveeb background" />
          </div>
          <div className="bg-card">
            <video autoPlay muted loop playsInline>
              <source src="/assets/vid 1.mp4" type="video/mp4" />
            </video>
          </div>
        </div>

        <div className="hero-overlay">
          <div className="main-word">
            <svg className="smiley" viewBox="0 0 100 100" fill="none">
              <circle cx="50" cy="50" r="45" stroke="#22c55e" strokeWidth="3" fill="none"/>
              <circle cx="35" cy="40" r="5" fill="#22c55e"/>
              <circle cx="65" cy="40" r="5" fill="#22c55e"/>
              <path d="M 30 65 Q 50 80 70 65" stroke="#22c55e" strokeWidth="3" fill="none" strokeLinecap="round"/>
            </svg>
            <span className="letter">l</span>
            <span className="letter">i</span>
            <span className="letter">v</span>
            <span className="letter">e</span>
            <span className="letter">e</span>
            <span className="letter">b</span>
          </div>
          <p className="tagline">Making Life Easier</p>
        </div>

        <div className="about-hero-bottom">
          <p className="bottom-description">Oliveeb was born from a simple yet powerful dream—to use technology to make everyday life easier. Our founders envisioned a world where technology seamlessly integrates into daily routines, solving real-life problems with effortless simplicity. Their goal was to develop applications that are not only highly functional but also intuitive and user-friendly, ensuring a smooth and satisfying experience for everyone.</p>
          <p className="bottom-description">This vision continues to drive us today as we push the boundaries of innovation, constantly exploring new ways to make technology more intuitive and impactful. We remain committed to developing solutions that simplify complex challenges, ensuring that technology works for people, not the other way around. As we move forward, we stay true to our philosophy—innovating with purpose, designing with clarity, and delivering solutions that make a real difference in people's lives.</p>
        </div>
      </section>

      <section className="philosophy-hero">
        <div className="philosophy-container">
          <h2 className="philosophy-title">Our Philosophy</h2>
          <p className="philosophy-text">At Oliveeb, we believe that the best technology is simple, intuitive, and effortlessly enhances everyday life. Our philosophy is rooted in creating solutions that prioritize ease of use while delivering exceptional customer satisfaction. By focusing on simplicity, we ensure that our products are accessible to everyone, and by prioritizing user experience, we build solutions that truly meet our customers' needs.</p>
          <p className="philosophy-text">At the heart of our innovation is a commitment to simplicity. We believe that technology should enhance life, not complicate it. Whether it's streamlining tasks, improving productivity, or enhancing well-being, our solutions are designed with the user in mind. By prioritizing ease of use and customer satisfaction, we create applications that empower individuals and businesses to navigate the modern world with confidence and efficiency.</p>
        </div>
      </section>

      <section className="about-content">
        <div className="about-content-container">
          <div className="about-hero-header">
            <span className="header-line"></span>
            <span className="header-text">Design · Develop · Innovate</span>
            <span className="header-line"></span>
          </div>

          <div className="about-three-columns">
            <div className="about-column">
              <div className="about-column-image">
                <div className="hexagon-frame">
                  <img src="/assets/image0.webp" alt="Oliveeb Mission" />
                </div>
              </div>
              <div className="about-column-text">
                <h2>Our Mission</h2>
                <p>At Oliveeb, our mission is to harness technology to simplify everyday life. We are committed to developing intuitive, user-friendly applications that deliver seamless experiences and true user satisfaction.</p>
              </div>
            </div>

            <div className="about-column">
              <div className="about-column-image">
                <div className="hexagon-frame">
                  <img src="/assets/image3.webp" alt="Oliveeb Team" />
                </div>
              </div>
              <div className="about-column-text">
                <h2>Our Team</h2>
                <p>The Oliveeb team brings expertise from top companies like Google, Microsoft, Amazon, Disney, and Walmart. Our diverse backgrounds fuel innovation, creativity, and excellence, making us stronger and more impactful in everything we do.</p>
              </div>
            </div>

            <div className="about-column">
              <div className="about-column-image">
                <div className="hexagon-frame">
                  <img src="/assets/image4.webp" alt="Oliveeb Innovation" />
                </div>
              </div>
              <div className="about-column-text">
                <h2>Our Innovations</h2>
                <p>At Oliveeb, we are passionate about what we do and take pride in our work. We focus on building applications with simplicity and user satisfaction at the forefront. Enjoy a seamless and fulfilling experience with every product we create!</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;